import { SideNavLinkConfig, SideNavSectionConfig, SideNavStyle } from './types';
import { SideNavLink } from './SideNavLink';
import { isSection } from './utils';
import { SideNav } from './SideNav';

type SideNavLinkListProps = {
  linksOrSection: (SideNavLinkConfig | SideNavSectionConfig)[];
  isSubLink?: boolean;
};

export const SideNavLinkList: React.FC<React.PropsWithChildren<SideNavLinkListProps>> = ({
  linksOrSection,
  isSubLink = false,
}) => {
  return (
    <>
      {linksOrSection.map((linkOrSection) => {
        const isNavSection = isSection(linkOrSection);
        return isNavSection ? (
          <SideNav
            linksAndSections={[linkOrSection]}
            style={SideNavStyle.nested}
            key={linkOrSection.header}
          />
        ) : (
          <SideNavLink key={linkOrSection.name} isSubLink={isSubLink} {...linkOrSection}>
            {linkOrSection.name}
          </SideNavLink>
        );
      })}
    </>
  );
};
